<form [formGroup]="form" class="tw:flex tw:flex-col tw:justify-center tw:p-4 tw:mb-">
  <div class="tw:mb-6 tw:w-full tw:text-center tw:text-xl tw:font-semibold tw:text-primary-500">
    {{ 'DATE_RANGE_MODAL.title' | translate }}
  </div>

  <div class="tw:flex tw:flex-col tw:px-8">
    <div class="form-group">
      <label>{{ 'DATE_RANGE_MODAL.dateInit' | translate }}</label>
      <input
        [minDate]="startMinDate"
        [maxDate]="startMaxDate"
        [class.is-invalid]="submitAttempted() && !form.get('dateInit')?.valid"
        class="form-control mb-3"
        placeholder="{{ 'DATE_RANGE_MODAL.dateFormat' | translate }}"
        bsDatepicker
        formControlName="dateInit"
        [bsConfig]="bsConfig"
      />
    </div>

    <div class="form-group">
      <label>{{ 'DATE_RANGE_MODAL.dateEnd' | translate }}</label>
      <input
        [minDate]="endMinDate"
        [maxDate]="endMaxDate"
        [class.is-invalid]="submitAttempted() && !form.get('dateEnd')?.valid"
        class="form-control mb-3"
        placeholder="{{ 'DATE_RANGE_MODAL.dateFormat' | translate }}"
        bsDatepicker
        formControlName="dateEnd"
        [bsConfig]="bsConfig"
      />
    </div>

    <button (click)="setValues()" class="btn btn-md btn-primary">{{ 'DATE_RANGE_MODAL.filter' | translate }}</button>
  </div>
</form>
